import { memo, useMemo } from 'react';

import classNames from 'classnames';

import './index.scss';

interface ImageProps {
  className?: string;
  url: string;
  type: Image.Type;
}

// const makeAvatarPicture = (picture: string) => {
//   return picture.replace(/\?.*/, '') + '__op__resize,m_lfit,w_100,h_100__op__format,f_webp';
// };

const makeBadgePircture = (picture: string) => {
  return picture.replace(/\?.*/, '') + '__op__format,f_webp';
};

function Image(props: ImageProps) {
  const url = useMemo(() => {
    if (props.type === 'Avatar') {
      // return makeAvatarPicture(props.url);
      return props.url;
    } else if (props.type === 'Badge') {
      return makeBadgePircture(props.url);
    }
  }, [props.url, props.type]);

  const className = useMemo(() => {
    if (props.type === 'Avatar') {
      return classNames(props.className, 'avatar');
    } else if (props.type === 'Badge') {
      return classNames(props.className, 'badge');
    }
  }, [props.type]);

  return <img className={className} src={url} />;
}

export default memo(Image);
